import DeleteIcon from '@mui/icons-material/Delete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';


const CustomCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(2),
  backgroundColor: 'rgba(51, 107, 135, 0.1)',
  boxShadow: theme.shadows[3],
  position: 'relative', // Para posicionar elementos absolutos dentro
}));

const CustomCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(4), // Se agrega espacio superior para que no se superponga el icono
}));

const QuestionTypeTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'montserrat',
  fontSize: '1rem',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
}));

const QuestionCountTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'montserrat',
  fontSize: '1rem',
  color: theme.palette.text.secondary,
}));

export default function ResumenTipoPreguntas({ tipoPreguntas, eliminarPregunta }) {
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      sx={{
        width: '100%',
        position: 'relative',
        borderRadius: '8px',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '2px solid transparent',
          borderRadius: 'inherit',
          borderImage:
            'repeating-linear-gradient(90deg, #E7E7E7, #E7E7E7 10px, transparent 10px, transparent 20px) 1',
          pointerEvents: 'none',
        },
      }}
    >
      <Grid container>
        {(Array.isArray(tipoPreguntas) ? tipoPreguntas : []).map((pregunta, index) => (
          <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
            <CustomCard>
              {/* Icono de eliminar en la esquina superior derecha */}
              <IconButton
                onClick={() => eliminarPregunta(index)}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: '#336B87',
                }}
              >
                <DeleteIcon />
              </IconButton>
              <CustomCardContent>
                <QuestionTypeTypography sx={{ color: '#336B87' }}>
                  {pregunta.tipo_preguntas}:
                </QuestionTypeTypography>
                <QuestionCountTypography sx={{ color: '#336B87' }}>
                  {pregunta.cantidad_preguntas} preguntas
                </QuestionCountTypography>
              </CustomCardContent>
            </CustomCard>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}

ResumenTipoPreguntas.propTypes = {
  tipoPreguntas: PropTypes.func.isRequired,
  eliminarPregunta: PropTypes.func.isRequired,
};
